module.exports = require('./EntityNameChangeApplicationView');
